module.exports = require('./EntityNameChangeApplicationView');
